import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";
import { useLang } from "@/i18n/LangContext";

export const EditorialMarquee = ({ dark = false }) => {
  const { t } = useLang();
  return (
  <div
    className={`relative overflow-hidden border-y py-6 md:py-8 ${
      dark ? "bg-ink border-cream/10" : "bg-sand/60 border-ink/5"
    }`}
    aria-hidden="true"
  >
    <Marquee speed={35} gradient={false} pauseOnHover>
      {t.home.marquee.map((w) => (
        <span key={w} className="flex items-center shrink-0">
          <span
            className={`font-display text-2xl md:text-4xl font-semibold tracking-tight uppercase ${
              dark ? "text-cream/90" : "text-ink/80"
            }`}
          >
            {w}
          </span>
          <Asterisk className="w-6 h-6 md:w-8 md:h-8 mx-8 md:mx-12 text-terracotta" strokeWidth={1.5} />
        </span>
      ))}
    </Marquee>
  </div>
  );
};
